module.exports = __webpack_public_path__ + "static/media/trust-eth.eec44f6e.png";